var _path;
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 8h-3V4.75a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75V8h-8V4.75a.752.752 0 00-.75-.75h-2.5a.752.752 0 00-.75.75V8H9a3 3 0 00-3 3v22a3 3 0 003 3h22a3 3 0 003-3V11a3 3 0 00-3-3zm-.375 25H9.375A.376.376 0 019 32.625V14h22v18.625a.376.376 0 01-.375.375z"
  })));
}
export default SvgCalendar;